import { useCallback } from "react";
import { useCartContext, useAuthContext } from "../../../app/providers/contextIndex";
import { resetAffariUserContext } from "../../../services/backend/authService";

const useTopbarSession = ({ toastRef }) => {
  const { clearCart } = useCartContext();
  const { endSession } = useAuthContext();

  const handleLogout = useCallback(() => {
    resetAffariUserContext();
    endSession();
    clearCart();
    toastRef.current?.show({
      severity: "success",
      summary: "Sesión cerrada",
      detail: "Has cerrado sesión correctamente.",
      life: 3000,
    });
  }, [endSession, clearCart, toastRef]);

  return { handleLogout };
};

export default useTopbarSession;